export default __webpack_public_path__ + "static/media/annaizu.cf94de9c.jpeg";